import { Controller } from '@hotwired/stimulus';
export default class ApplicationController extends Controller {
  connect() {
    this.disposers = [];
    this.connected = true;
    this.start?.();
  }
  disconnect() {
    this.connected = false;
    this.stop?.();
    for (const dispose of this.disposers.splice(0).reverse()) dispose();
  }
  cleanup(dispose) {
    this.disposers.push(dispose);
    return dispose;
  }
  listen(target, event, listener, options) {
    target?.addEventListener(event, listener, options);
    this.cleanup(() => target?.removeEventListener(event, listener, options));
  }
  observe(observer, element = this.element) {
    observer.observe(element);
    this.cleanup(() => observer.disconnect());
    return observer;
  }
  emit(name, detail = {}) {
    document.dispatchEvent(new CustomEvent(`aura:${name}`, { detail }));
  }
}
